import React from 'react';
import PropTypes from 'prop-types';
// import { styled } from '@mui/material/styles';  // withStyles alternative
import { withStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Popover from '@mui/material/Popover';
import dropdown from '../assets/images/dropdown.svg';
// import { history } from './../routers/Router';
import logout from '../assets/images/logout.svg';


const styles = theme => ({
  typography: {
    // margin: theme.spacing.unit * 1,
    margin: '0px',
    borderRadius: '5px'

  },

});

class LogoutButton extends React.Component {
  state = {
    anchorEl: null,
  };

  handleClick = event => {
    this.setState({
      anchorEl: event.currentTarget,
    });
  };

  handleClose = () => {
    this.setState({
      anchorEl: null,
    });
  };

  Logout = (e) => {
    localStorage.removeItem('token');
    window.location.href = '/';
  }

  render() {
    const { classes } = this.props;
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);

    return (
      <React.Fragment>
        <img src={dropdown} style={{ width: '11px', height: '6px', margin: '27px 15px 27px 0px' }}
          aria-owns={open ? 'simple-popper' : undefined}
          aria-haspopup="true"
          variant="contained"
          onClick={this.handleClick}
        />
        <Popover
          id="simple-popper"
          open={open}
          anchorEl={anchorEl}
          onClose={this.handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',

          }}
          classes={{ backgroundColor: 'red' }}

          style={{ top: '30px', }}
        >
          <Typography className={classes.typography} style={{ width: '110px', padding: '10px', backgroundColor: 'transparent', cursor: 'pointer' }}
            onClick={() => {
              localStorage.removeItem('token');
              window.location.href = '/';
            }}
          >
            <div className="">
              <img src={logout} style={{ marginRight: '20px' }} />Logout

            </div>


          </Typography>
        </Popover>
      </React.Fragment>
    );
  }
}

LogoutButton.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LogoutButton);
